import React, { Component } from 'react';
import Icon from '../../icons';

class FormSelectSearch extends Component {
    selectedRef;
    menuRef;
    state = {   
        isOpen: false,
        searchText:"",
        menuOptions:[],
        selectedItem:0,
        isHovered: true,
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutsideSelect);
        this.setState({menuOptions :  this.props.options});
    }

    componentDidUpdate(prevProps) {
        // Sync menuOptions with props.options when options array changes (e.g., pagination append)
        if (prevProps.options !== this.props.options) {
            // Preserve current search filter when options change
            if (this.state.searchText) {
                this.onSearch(this.state.searchText);
            } else {
                this.setState({ menuOptions: this.props.options });
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onClickOutsideSelect);
    }

    handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        // Trigger onScrollEnd when scrolled near the bottom (within 50px)
        if (this.props.onScrollEnd && (scrollHeight - scrollTop - clientHeight < 50)) {
            this.props.onScrollEnd();
        }
    }

    onClickOutsideSelect = (e) => {
        if (this.menuRef && !this.menuRef.contains(e.target)) {
            this.closeDropDown();
        }
    }

    openDropDown = () => {
        this.setState({
            isOpen: true,
            menuOptions:this.props.options
        },() =>{
                $(".select2-results").scrollTop(0);
        })
       
    }

    closeDropDown = () => {
        this.setState({
            isOpen: false,
            searchText: '',
            selectedItem:0
        })
    }
    
    onSearchText = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            searchText: e.target.value
        })
        this.onSearch(e.target.value);
    }

    onSearch = (key) => { 
        if(key==="") {
            this.setState({menuOptions: this.props.options});
        } else {
           var filteredList =this.props.options.filter(option => option.DisplayName ? option.DisplayName.toLowerCase().includes(key.toLowerCase()) : option.Item2 ?  option.Item2.toLowerCase().includes(key.toLowerCase()): option.Name.toLowerCase().includes(key.toLowerCase()));
           this.setState({menuOptions: filteredList});
        }
    }

    onSelected = (option) => {
        if(!option.disabled) {
            if(this.props.selected !== option.Value || option.Item1 || option.Name) {
                const data={
                    name:this.props.Id,
                    option:option
                }
                // Support redux-form's input.onChange (from Field wrapper)
                if (this.props.input && this.props.input.onChange) {
                    this.props.input.onChange(option.Value || option.Item1 || option.Name);
                }
                // Support legacy onSelect callback
                if (this.props.onSelect) {
                    this.props.onSelect(data);
                }
            }
            this.closeDropDown();
        }
    }

    handleKeyDown = (e) => {
        if (e.keyCode === 40 || e.keyCode === 38) {
            let selector = this.props.Id, newSelected, listSize = this.state.menuOptions.length, list = this.state.menuOptions;
            
            newSelected = this.state.selectedItem;
            if (e.keyCode == 38) {   // Up
                newSelected = this.state.selectedItem === 0 ? 0 : this.state.selectedItem - 1;
            } else if (e.keyCode === 40) { // Down
                newSelected = this.state.selectedItem===listSize-1?listSize-1:(this.state.selectedItem + 1) % listSize;
            }
            this.setState({
                selectedItem: newSelected,
            });
            const Id =list[0].hasOwnProperty("Item1") ?  list[newSelected].Item1 : list[0].hasOwnProperty("Name") ? list[newSelected].Name  :list[newSelected].Value;

            if (newSelected === listSize - 1) {                       //ending
               // document.getElementById(Id).scrollIntoView();
                return;
            } else if (newSelected === 0) {
                document.getElementById(selector).scrollTo(0, 0);     //begining
                return;
            }

            const scrollTop = document.getElementById(selector).scrollTop;
            const selectedElementTop = document.getElementById(Id).offsetTop;
            const selectedElementHeight = document.getElementById(Id).offsetHeight;
            const scrollWindowHeight = document.getElementById(selector).offsetHeight;

            // no scroll if selected element top position and bottom position is inside the scroll window
            if (selectedElementTop > scrollTop + 80 && selectedElementTop + selectedElementHeight < scrollTop + scrollWindowHeight) {
                return;
            }
            if (e.keyCode == 38) {
                document.getElementById(selector).scrollBy(0, -selectedElementHeight)
            } else if (e.keyCode === 40) {
                document.getElementById(selector).scrollBy(0, selectedElementHeight)
            }
        }
        else if (e.keyCode === 13) {
            if (this.state.menuOptions.length > 0 && (this.state.selectedItem!=-1 || this.state.searchText.length > 0)) {
                const selectOption = this.state.menuOptions[this.state.selectedItem != -1 ? this.state.selectedItem : 0];
                this.onSelected(selectOption);
            }
        } else if(e.keyCode===9) {
            const selectOption = this.state.menuOptions[this.state.selectedItem != -1 ? this.state.selectedItem : 0];
                this.onSelected(selectOption);
                this.setState({isOpen:false});
        }
    }

    toggleHover =(e)=> {
        this.setState(prevState => ({
            isHovered: !prevState.isHovered,
            selectedItem:e
        }));
    }

    handleKeyDropDown =(e)=> {
        if(e.keyCode===40) {
            if(!this.state.isOpen){
                this.setState({isOpen:true,
                              menuOptions:this.props.options});
            }
        }
    }

    onFocus=()=>{
        if(this.props.onFocus){
            this.props.onFocus();
        }
    }

    selectedOption=(options)=>{
      let selectedItem;
      if(options.length >0){
         if(options[0].hasOwnProperty("Item1")){
            selectedItem= options.find(option => option.Item1== this.props.selected) 

         }
         else if(options[0].hasOwnProperty("Name")){
            selectedItem= options.find(option => option.Name== this.props.selected);   

         }else{
            selectedItem= options.find(option => option.Value== this.props.selected);   

         }
        return selectedItem;
      }  

    }


    render() {
        const { Id,options, iconName, openOnHover, openOnClick, title } = this.props;
        let selected=this.selectedOption(options);
        return (
            <div className="wth-9">
            <div tabIndex={0} onKeyDown={this.handleKeyDropDown}  className={`mailDropdown select ${(this.props.meta && this.props.meta.touched && this.props.meta.error)? 'errorState':''} ${this.props.isDisabled ? "disabled":''}`}
                onMouseLeave={openOnHover ? this.closeDropDown : () => {}}>
                <div className={`alignMiddle rowSpaceBetween flexGrow ${this.props.isDisabled ?"disabled":""}`}
                  onClick={!this.props.isDisabled ? openOnClick ? (this.state.isOpen ? this.closeDropDown : this.openDropDown) : () => {}:null}
                    onMouseOver={openOnHover ? this.openDropDown : () => {}} onFocus={this.onFocus} >
                    { selected ? 
                        <span>{selected.DisplayName || selected.Item2 || selected.Name }</span> : 
                        title && <span>{ title}</span>  
                    }
                    { iconName && <Icon name="selectArrow" className="icon" />}
                
                </div>
                {this.state.isOpen &&
                <div ref={(node) => { this.menuRef = node }} className={`mailingSearch ${this.props.isOpenRight ? 'openRight' :''} openTop ${this.state.isOpen ? "onClick" : ''} `} >
                    <div className="carrierSticky">
                        <input autoFocus={true} type="text"  onKeyDown={this.handleKeyDown} onChange={this.onSearchText} value={this.state.searchText} id={`${Id}InputBox`}   autoComplete="new-password" maxLength="200" autoCorrect="off" autoCapitalize="off"  />
                    </div>
                    <div className="select2-results" id={Id} onScroll={this.handleScroll} >
                        {this.state.menuOptions && this.state.menuOptions.map((option, index) => (
                            <span
                                ref={(node) => { if(selected && (option.Value || option.Item1 || option.Name) === (selected.Value || selected.Item1 || selected.Name)) this.selectedRef = node}} 
                                onClick={(e) => { this.onSelected(option) }} 
                                key={index}
                            >
                                <a id={option.Value || option.Item1 || option.Name} onMouseEnter={ ()=>this.toggleHover(index)} onMouseLeave={()=>this.toggleHover(index)} 
                                    className={`pointer ${(this.state.selectedItem == index  ? 'activeElement':'' )} ${(selected && (selected.Value || selected.Item1 || selected.Name) == (option.Value || option.Item1 || option.Name)) ? 'active' : (option.disabled ? 'disabled' : '')}`} 
                                    >{option.DisplayName || option.Item2 || option.Name}
                                    </a>
                            </span>
                        ))}
                        {this.props.isLoadingMore && (
                            <span style={{paddingLeft:"12px", display:"block", padding:"8px 12px", color:"#666"}}>Loading more...</span>
                        )}
                    </div>
                    {this.state.menuOptions.length<=0 && !this.props.isLoadingMore && <span style={{paddingLeft:"12px"}}>No matches found</span> }
                </div>
                }
            {this.props.meta && this.props.meta.touched && this.props.meta.error &&
                <span className="required">{this.props.meta.error}</span>}
            </div>
            </div>
        )
    }
}

export default FormSelectSearch;